import { isAxiosError } from "axios";

export const getOtpSendErrorMessage = (error: unknown): string => {
  if (isAxiosError(error)) {
    const status = error.response?.status;
    const phoneError = error.response?.data?.errors?.phoneNumber;

    if (status === 429) {
      return "تعداد درخواست‌ها بیش از حد مجاز است؛ لطفاً مدتی بعد دوباره امتحان کنید";
    }

    if (status === 400 && phoneError === "maxAttemptsReached") {
      return "تعداد تلاش‌های مجاز تمام شده؛ کمی بعد دوباره امتحان کنید";
    }

    if (!error.response) {
      return "ارتباط با سرور برقرار نشد؛ اینترنت خود را بررسی کنید";
    }
  }

  return "مشکلی پیش آمده است! لطفا دوباره امتحان کنید";
};
